import React, { Component } from "react"
import { Link } from "gatsby"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import AOS from "aos"
import 'aos/dist/aos.css';
import newsArticleOne from "../../images/news/tetleys-invest-yutongs.jpg"
import NewsStrip from "../../components/news-strip"

class NewsPage extends Component {

  componentDidMount(){
    AOS.init();
    window.addEventListener('load', AOS.refresh);
    // @NOTE: Hack to force AOS to work :(
    window.setTimeout(AOS.refresh, 1000);
  }

  componentDidUpdate() {
    AOS.refresh();
  }

  render() {
    return (
      <Layout>
        <SEO title="Tetley’s Coaches Invests in Two New Yutong GT12 Coaches" description="We’re excited to announce the arrival of two brand-new 2025-registered Yutong GT12 coaches to the Tetley’s Coaches fleet. This investment is part of our ongoing commitment to providing safe, comfortable, and accessible travel for all our customers." />
        <div className="block-services inner-body-bg">
          <div className="body gutter page-content-parent page-article" style={{ background: 'white' }}>
            <div>
              <h1 className="page-content-heading">Tetley’s Coaches Invests in Two New Yutong GT12 Coaches</h1>
              <p className="news-article-date">April 2025</p>
            </div>

            <div className="news-article-body">
              <p className="news-article-img">
                <img src={newsArticleOne} alt="" />
              </p>
              <p>
              We’re excited to announce the arrival of two brand-new 2025-registered Yutong
GT12 coaches to the Tetley’s Coaches fleet. This investment is part of our
ongoing commitment to providing safe, comfortable, and accessible travel for
all our customers.
              </p>
              <p>Whether it’s a school trip, private hire, corporate travel, or a day out, these new
vehicles help us continue to deliver the reliable, high-quality service Tetley’s
Coaches is known for.</p>
<h2>Comfort, Safety, and Accessibility</h2>
              <p>The new Yutong GT12 coaches are packed with features designed to make
              every journey as smooth and enjoyable as possible. Highlights include:</p>
              <ul>
                <li>53 reclining seats, or 45 seats plus a dedicated wheelchair space</li>
                <li>Fully PSVAR compliant, with an electric wheelchair lift and secure floor
                mountings</li>
                <li>3-point seat belts fitted to every seat</li>
                <li>Climate control to keep the cabin comfortable all year round</li>
                <li>Personal charging points (USB-A and USB-C) at every seat</li>
                <li>Centre sunken toilet, Bosch multimedia system, and onboard fridge</li>
                <li>Spacious luggage compartments for all your gear</li>
                <li>Internal and external CCTV for extra security</li>
                <li>GPS tracking so we always know exactly where the coach is</li>
                <li>PA system and radio onboard</li>
              </ul>
              <h2>Built with Safety in Mind</h2>
              <p>Passenger safety is always our number one priority. Our new coaches come
              equipped with the latest safety systems, including:</p>
              <ul>
                <li>Advanced Emergency Braking System (AEBS) and Electronic
                Stability Control (ESC)</li>
                <li>Lane Departure Warning System to help keep journeys safe</li>
                <li>Full LED lighting for maximum visibility inside and out</li>
              </ul>
              <h2>A Word from Dan Milnes, Operations Manager</h2>
              <p>"Bringing these new Yutongs into the fleet is a big step forward for us. They’re
reliable, packed with great features, and meet all the latest standards for safety
and accessibility. Most importantly, they’ll help us keep delivering the high
level of service our customers expect."</p>
              <h2>Ready to Travel</h2>
              <p>We’re proud to continue investing in the future of Tetley’s Coaches and look
              forward to seeing passengers enjoy these fantastic new vehicles.</p>
              <p>If you'd like to know more about hiring one of our new coaches or any of our
              services, <Link to="/contact/">get in touch with us</Link> — we’re always happy to help.</p>
            </div>
          </div>
        </div>

        <NewsStrip />

      </Layout>
    );
  }
}

export default NewsPage
